// extracted by mini-css-extract-plugin
module.exports = {"root":"NextPrevLink_root__KENLx","disabled":"NextPrevLink_disabled__jAM-e"};